<template>
  <DetailsListEntry v-if="!edit" class="ma-0" :title="element.label" :content="model" :suffix="element.unit" />
  <NumberField
    v-else
    v-model="model"
    :title="element.label"
    :placeholder="element.placeholder"
    :mark="invalid"
    :suffix="element.unit"
    :data-test="`input-${element.name}`"
    @invalid="$emit('invalid', $event)"
  />
</template>

<script lang="ts">
import { logger, NumberElement } from '@anschuetz-elog/common';
import { cloneDeep } from 'lodash';
import { computed, defineComponent, PropType, toRef } from 'vue';

import DetailsListEntry from '#/components/DetailsListEntry.vue';
import NumberField from '#/components/NumberField.vue';

export default defineComponent({
  name: 'FormulateNumberField',

  components: {
    DetailsListEntry,
    NumberField,
  },

  props: {
    element: {
      type: Object as PropType<NumberElement>,
      required: true,
    },

    value: {
      type: Object as PropType<Record<string, unknown>>,
      required: true,
    },

    edit: {
      type: Boolean,
    },

    invalid: {
      type: Boolean,
    },
  },

  emits: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    input: (_value: Record<string, unknown>) => true,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    invalid: (_invalid: boolean) => true,
  },

  setup(props, { emit }) {
    const value = toRef(props, 'value');
    const element = toRef(props, 'element');

    const model = computed<number | string | undefined>({
      get() {
        const v = value.value[element.value.name];
        if (v !== undefined && typeof v !== 'string' && typeof v !== 'number') {
          logger.error(
            'Value does not fit to number element',
            'value:',
            cloneDeep(v),
            'element:',
            cloneDeep(element.value),
          );
          return undefined;
        }
        return v;
      },
      set(newElementValue) {
        emit('input', { ...value.value, [element.value.name]: newElementValue });
      },
    });

    return { model };
  },
});
</script>
